import { render, staticRenderFns } from "./ShopCartPage.vue?vue&type=template&id=73c844e8&scoped=true&"
import script from "./ShopCartPage.vue?vue&type=script&lang=js&"
export * from "./ShopCartPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c844e8",
  null
  
)

export default component.exports